/**
 * Script para corrigir problemas de cache de autenticação
 * Execute no console do navegador se estiver com problemas de "Sem empresa"
 */

export const fixAuthCache = async () => {
  console.log('🔧 Iniciando correção de cache...');
  
  try {
    // 1. Limpar cache antigo
    const authStorage = localStorage.getItem('auth-storage');
    if (authStorage) {
      const parsed = JSON.parse(authStorage);
      
      // Se tem tokens mas não tem company_name, forçar atualização
      if (parsed.state?.accessToken && parsed.state?.user && !parsed.state?.user?.company_name) {
        console.log('❌ Usuário sem empresa detectado, forçando atualização...');
        
        // Buscar perfil atualizado via API
        const response = await fetch('/api/v1/auth/profile/', {
          headers: {
            'Authorization': `Bearer ${parsed.state.accessToken}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (response.ok) {
          const userData = await response.json();
          console.log('✅ Dados atualizados recebidos:', userData);
          
          // Atualizar o estado
          parsed.state.user = {
            ...parsed.state.user,
            ...userData
          };
          
          // Salvar de volta
          localStorage.setItem('auth-storage', JSON.stringify(parsed));
          console.log('✅ Cache atualizado com sucesso!');
          console.log('🔄 Recarregando página em 2 segundos...');
          
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          console.error('❌ Erro ao buscar perfil:', response.status);
        }
      } else if (parsed.state?.user?.company_name) {
        console.log('✅ Usuário já tem empresa:', parsed.state.user.company_name);
      } else {
        console.log('⚠️ Estado inconsistente, limpando cache...');
        localStorage.removeItem('auth-storage');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.reload();
      }
    } else {
      console.log('❌ Nenhum cache de autenticação encontrado');
    }
  } catch (error) {
    console.error('❌ Erro ao corrigir cache:', error);
  }
};

// Auto-executar se detectar problema
const checkAndFix = () => {
  const authStorage = localStorage.getItem('auth-storage');
  if (authStorage) {
    try {
      const parsed = JSON.parse(authStorage);
      // Se está logado mas sem empresa (exceto superusuários)
      if (parsed.state?.user && 
          parsed.state?.accessToken && 
          !parsed.state?.user?.company_name && 
          !parsed.state?.user?.is_superuser) {
        console.warn('⚠️ Problema detectado: Usuário sem empresa. Execute: authFix()');
        return true;
      }
    } catch (e) {
      console.error('Erro ao verificar cache:', e);
    }
  }
  return false;
};

// Exportar para o window
if (typeof window !== 'undefined') {
  (window as any).authFix = fixAuthCache;
  (window as any).authCheck = checkAndFix;
  
  // Verificar automaticamente
  if (checkAndFix()) {
    console.log('💡 Dica: Execute authFix() no console para corrigir o problema');
  }
}

export default fixAuthCache;